<template>
    <div>
        <div class="wrapper-x-40">
            <h1>Обновления</h1>
        </div>

        <div class="versions-info">
            <div class="wrapper-x-40">
                <div class="mb-4">
                    <button
                        class="btn btn-default button__check-update"
                        @click="checkUpdate"
                    >
                        Проверить обновления
                    </button>
                </div>
                <div class="current-version mb-2">
                    Ваша версия web-приложения KPam-3D: v
                    {{ version?.current_version_number }}
                </div>
                <div class="actual-version mb-3" v-if="version?.version_number">
                    Актуальная версия web-приложения KPam-3D: v
                    {{ version.version_number }}
                </div>
                <div class="actual-version mb-3" v-else>
                    Данные об актуальной версии отсутствуют. Нажмите «Проверить обновления».
                </div>
                <div
                    class="need_update mb-3"
                    :class="{
                        'need_update-yes': version?.need_update,
                        'need_update-no': !version?.need_update,
                    }"
                >
                    {{
                        !version?.version_number
                            ? "Обновление недоступно без актуальных данных. Нажмите «Проверить обновления»."
                            : version.need_update
                            ? "Есть обновления, Вам необходимо обновить систему!"
                            : "Обновление не требуется, у Вас актуальная версия!"
                    }}
                </div>
                <div class="updates-info mb-4">
                    Настоятельно рекомендуем перед установкой обновлений сделать
                    резервную копию вашей установленной системы KPam-3D! В
                    противном случае будет не возможно восстановить систему и
                    данные будут безвозвратно утеряны в случае если возникнет
                    сбой установки или что-то пойдёт ни так!
                </div>

                <div class="backup-instruction mb-8">
                    <a href="#">
                        Инструкция как сделать резервную копию web-приложения
                        KPam-3D
                    </a>
                </div>
                <div class="updates-actions" v-if="version?.need_update">
                    <button
                        v-if="!isInstalling"
                        class="btn btn-green button-updates-go"
                        :disabled="loading"
                        @click="install"
                    >
                        Обновить
                    </button>
                    <div v-if="isInstalling">
                        <img src="/images/icons/update-animation.gif" alt="" />
                    </div>
                    <div v-if="version.need_update">
                        до v {{ version.version_number }}
                    </div>
                </div>
            </div>
        </div>

        <div class="upgrade-info wrapper-x-40 mt-8" v-if="updatingProgress">
            <h2>Данные об обновлении</h2>

            <div
                class="upgrade-info__failed"
                v-if="
                    updatingProgress.failed &&
                    parseInt(updatingProgress.failed) == 1
                "
            >
                Обновление завершилось неудачей
            </div>
            <div class="upgrade-info__version">
                Версия обновления:
                <span>{{ updatingProgress.version_to }}</span>
            </div>
            <div
                class="upgrade-info__message"
                v-if="updatingProgress.version_to"
            >
                {{ updatingProgress.message }}
            </div>
            <div class="upgrade-info__progress">
                Прогресс: <span>{{ updatingProgress.progress }}%</span>
            </div>
            <div class="upgrade-info__start_finish">
                <div class="upgrade-info__start">
                    Начало: <span>{{ updatingProgress.started_at }}</span>
                </div>
                <div class="upgrade-info__start">
                    Завершение: <span>{{ updatingProgress.finished_at }}</span>
                </div>
            </div>
            <div
                class="upgrade-info__stages"
                v-if="updatingProgress.upgrade_stages"
            >
                <div class="upgrade-stage__title">Стадии обновления</div>
                <div
                    class="upgrade-stage"
                    v-for="(stage, index) of updatingProgress.upgrade_stages"
                    :key="`stage-${stage.id}`"
                >
                    <div>
                        <div class="upgrade-stage__index">{{ index + 1 }}.</div>
                        <div>
                            <div class="upgrade-stage__name">
                                {{ stage.name }}
                                <span
                                    v-if="
                                        stage.success &&
                                        parseInt(stage.success) === 1
                                    "
                                >
                                    <i class="fa fa-check"></i>
                                </span>
                                <span
                                    v-if="
                                        stage.failed &&
                                        parseInt(stage.failed) === 1
                                    "
                                >
                                    <i class="fa fa-times"></i>
                                </span>
                            </div>

                            <div
                                v-if="
                                    stage.processing &&
                                    parseInt(stage.processing) === 1
                                "
                            >
                                <img
                                    src="/images/icons/update-animation.gif"
                                    alt=""
                                />
                            </div>
                            <div
                                v-if="stage.message"
                                class="upgrade-stage__message"
                                :class="{
                                    error:
                                        stage.failed &&
                                        parseInt(stage.failed) === 1,
                                }"
                            >
                                {{ stage.message }}
                            </div>
                            <div>Прогресс - {{ stage.progress }}%</div>
                        </div>
                    </div>
                </div>

                <div
                    class="mt-4"
                    v-if="
                        updatingProgress &&
                        !updatingProgress.processing &&
                        parseInt(updatingProgress.processing) === 0
                    "
                >
                    <img
                        v-if="loading"
                        src="/images/icons/update-animation.gif"
                        alt=""
                    />
                    <button
                        v-else
                        class="btn btn-red btn-small"
                        @click="clearUpgrade"
                    >
                        Очистить данные обновления
                    </button>
                    <span class="text-xs font-italic"
                        >Будут также удалены загруженные файлы</span
                    >
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "Updates",
    data() {
        return {
            checkInstallInterval: null,
        };
    },

    computed: {
        settings() {
            return this.$store.state.settings.settings;
        },
        version() {
            return this.$store.state.versions.version;
        },
        loading() {
            return this.$store.state.versions.loading;
        },
        licensed() {
            return this.$store.getters["licensed"];
        },
        updatingProgress() {
            const updatingProgress =
                this.$store.state.versions.updatingProgress;

            if (
                updatingProgress &&
                !updatingProgress.processing &&
                parseInt(updatingProgress.processing) === 0
            ) {
                clearInterval(this.checkInstallInterval);
                this.checkInstallInterval = null;
            }

            return updatingProgress;
        },

        isInstalling() {
            return (
                this.updatingProgress &&
                this.updatingProgress.processing &&
                parseInt(this.updatingProgress.processing) === 1
            );
        },
    },

    methods: {
        checkUpdate() {
            this.$store.dispatch("versions/checkUpdates");
        },

        install() {
            this.$store.dispatch("versions/install");
            if (this.checkInstallInterval) {
                clearInterval(this.checkInstallInterval);
                this.checkInstallInterval = null;
            }

            this.checkInstallInterval = setInterval(() => {
                this.$store.dispatch("versions/checkUpgradeInfo");
                console.log("update--interval");
            }, 2000);
        },

        clearUpgrade() {
            this.$store.dispatch("versions/clearUpgrade");
        },
    },
};
</script>
<style lang="scss" scoped>
.button__check-update {
    font-size: 16px;
    background-color: #fff;
    &:hover {
        color: inherit;
    }
}
.current-version,
.actual-version {
    font-size: 18px;
}
.actual-version {
    color: #009543;
}
.need_update {
    font-size: 24px;
    font-weight: 600;
    &.need_update-no {
        color: #009543;
    }
    &.need_update-yes {
        color: #ff0000;
    }
}
.updates-info {
    font-size: 14px;
}
.backup-instruction {
    font-size: 14px;
    a {
        display: inline-block;
        border-bottom: 1px solid;
        &:hover {
            border-bottom: 1px solid transparent;
        }
    }
}
.updates-actions {
    display: flex;
    align-items: center;
    gap: 20px;
    button {
        border-color: #009543;
        padding: 4px 20px;
        &:disabled {
            opacity: 0.3;
            cursor: default;
            &:hover {
                cursor: default;
                background-color: #009543;
            }
        }
    }
    div {
        font-size: 24px;
    }
}
.versions-list {
    font-size: 14px;
}
</style>
